import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { showRankAtom } from '@/atoms/table';
import { DataPillGradientLegend } from './DataPillGradientLegend';

export const RankDataPillLegend = ({ resultsCount }: { resultsCount?: number | null }) => {
  const { t } = useTranslation('radar');
  const showRank = useAtomValue(showRankAtom);

  if (!showRank || !resultsCount) return null;

  return <DataPillGradientLegend title={t('legend.rankColouring')} resultsCount={resultsCount} />;
};
